import { getQaSelector } from '../../../../../../../utils/common'
import { Skeleton } from '../../../../../../Skeleton'
import {
  LISTING_PHOTO_MOSAIC_SKELETON_CELLS,
  QA_NAME_LISTING_PHOTO_MOSAIC_SKELETON,
} from '../RentalPortalListingPhotoMosaic.constants'

import * as styles from '../RentalPortalListingPhotoMosaic.module.css'

function RentalPortalListingPhotoMosaicSkeleton() {
  return (
    <div
      {...getQaSelector({ value: QA_NAME_LISTING_PHOTO_MOSAIC_SKELETON })}
      className={styles.mosaic}
    >
      <Skeleton className={styles.heroSkeleton} />
      <div className={styles.grid}>
        {LISTING_PHOTO_MOSAIC_SKELETON_CELLS.map(cell => (
          <Skeleton className={styles.cellSkeleton} key={cell} />
        ))}
      </div>
    </div>
  )
}

export default RentalPortalListingPhotoMosaicSkeleton
